import { useLibraryEntry } from "../lib/queries";

interface LibraryEntryVideo {
  id: string;
  video_url: string | null;
}

/**
 * A "Video" chip, shown only when there is actually a video.
 *
 * The chip used to be rendered from `element.libraryEntryId` alone -- i.e. from "this exercise is linked
 * to a library entry", which is a different fact. Every entry in the library had `video_url: null` and
 * every exercise still advertised a walkthrough (UX review F57).
 *
 * That is worse than showing no chip at all. "Am I doing it right?" is the question a nine-year-old
 * needs answered mid-exercise, and a promise of a demonstration that isn't there sends her to find a
 * parent -- which, per her persona, is where the session ends.
 *
 * Read live from the entry, like the cues beside it, so attaching a video later makes the chip appear
 * on every plan referencing that exercise without touching any of them. Renders nothing while loading
 * or on error: a chip that flickers in and out is worse than one that arrives a moment late.
 */
export function VideoBadge({ entryId }: { entryId?: string }) {
  const query = useLibraryEntry<LibraryEntryVideo>(entryId);
  if (!entryId || !query.data?.video_url) return null;
  return <span className="badge badge-ok">Video</span>;
}
